// Thin wrappers around full-page navigation so they can be mocked in tests
// (jsdom 26 makes window.location and its methods non-configurable).
export const redirectTo = (url: string): void => {
  window.location.assign(url);
};

export const replaceWith = (url: string): void => {
  window.location.replace(url);
};
